import React, { useEffect, useState } from 'react';
import {
  Card, Table, Button, message,
} from 'antd';
import { useParams, Link } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { ArrowLeftOutlined } from '@ant-design/icons';
import makeColumns from './tableColumn';
import { ACTIVITIES } from '../../../routes';
import { GET_ACTIVITY_SUBMISSIONS, DELETE_ACTIVITY_SUBMISSION } from '../../../graphql';
import DetailModal from './DetailModal';
import './styles.less';

const Submission = () => {
  const { activityId } = useParams();
  const {
    data: submissionPayload, loading: submissionLoading, refetch,
  } = useQuery(GET_ACTIVITY_SUBMISSIONS, { variables: { activityId } });
  const [deleteActivity] = useMutation(DELETE_ACTIVITY_SUBMISSION);
  const [submissions, setSubmissions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  // A submission is addressed by its activity and its author, not an id of
  // its own — it is embedded on the assignment record.
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleViewClick = (userId) => {
    setSelectedUserId(userId);
    setShowModal(true);
  };
  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleDeleteClick = async (userId) => {
    try {
      await deleteActivity({
        variables: { activityId, userId },
        update: (cache) => {
          const cached = cache.readQuery({
            query: GET_ACTIVITY_SUBMISSIONS,
            variables: { activityId },
          });
          if (!cached) return;
          cache.writeQuery({
            query: GET_ACTIVITY_SUBMISSIONS,
            variables: { activityId },
            data: {
              submissions: cached.submissions.map((row) => (
                row.userId === userId ? { ...row, status: 'NOT_SUBMITTED', submission: null } : row
              )),
            },
          });
        },
      });
    } catch (error) {
      message.error(error.message || 'Error, could not withdraw submission');
    }
  };
  useEffect(() => {
    if (!submissionLoading && submissionPayload) {
      const { submissions: submissionRes } = submissionPayload;
      setSubmissions(submissionRes);
    }
  }, [submissionLoading, submissionPayload]);
  return (
    <div className="gx-mb-4 submission-wrapper">
      {showModal && (
        <DetailModal
          showModal={showModal}
          activityId={activityId}
          userId={selectedUserId}
          setShowModal={setShowModal}
        />
      )}
      <Link to={ACTIVITIES}>
        <Button>
          <ArrowLeftOutlined />
        </Button>
      </Link>
      <Card title="Activity Submissions">
        <Table
          loading={submissionLoading}
          className="gx-table-responsive"
          columns={makeColumns(handleViewClick, handleDeleteClick)}
          dataSource={submissions}
          rowKey="userId"
        />
      </Card>
    </div>
  );
};

export default Submission;
